/**
 * The training session id the page was opened with, or undefined.
 *
 * The admin portal mints one id per launch (`<track-name>-<uuid>`, see its
 * utils/trainingNavigation.ts) and SSO puts it in /training/session/:sessionId.
 * Both training pages used to accept only a 24-hex ObjectId, so they threw that
 * id away and the server minted a new one on every start: the "already ended"
 * check then looked up an id nobody had saved, and a refreshed page ran the
 * session again (2026-09-26). A hand-typed local URL uses the placeholder
 * "new", which is still dropped so the server mints one.
 */
const SESSION_ID_PATTERN = /^[A-Za-z0-9_-]{8,128}$/;
const PLACEHOLDER_SESSION_IDS = new Set(['new']);

export function usableSessionId(value?: string | null): string | undefined {
  const candidate = (value ?? '').trim();
  if (!candidate || PLACEHOLDER_SESSION_IDS.has(candidate.toLowerCase())) return undefined;
  return SESSION_ID_PATTERN.test(candidate) ? candidate : undefined;
}
